import React, {Component} from 'react';
import NavBar from "../navbar/navbar";
import Footer from "../footer/footer";
import "./layout.scss";
import Modal from "../modal/modal";
import Seo from "../SEO/Seo";
import {HelmetProvider} from "react-helmet-async";

let description = `I’m an illustrator and designer who loves
            helping my clients communicate their
            stories through strategic, artful visuals.
            Check out some of my work below!`


class Layout extends Component {
    constructor(props){
        super(props);
        this.state = {
            hamburgerOpen:false,
        }
    }
    handleClick = () => {
        this.setState({
            hamburgerOpen: !this.state.hamburgerOpen,
        });
    };
    componentDidMount() {
        const { name, layout } = this.props;
        let pageName = name || "";
        let className = layout || pageName;
        document.body.className = `${className}`;
    }
    render() {
        const {hasModal , modalContent, slides, color,current} = this.props;
        const shouldSlide = slides ?? true;
        const willOpen = shouldSlide ? this.state.hamburgerOpen ? "open" : "close" : "";
        let setCounter = this.props?.setCounter;
        let counter = this.props?.counter;
        let max = this.props?.max
        return (
            <HelmetProvider>
            <div className={`layout ${this.props?.name}`} id={this.props.id}>
                <Seo
                    title={this.props.name || undefined}
                    description={this.props.description || description}
                    keywords={this.props.keywords || undefined}
                />
                {hasModal && modalContent && <Modal
                    max={max}
                    handleCounter={setCounter}
                    counter={counter}
                >{modalContent}</Modal> }
                <NavBar
                    open={this.state.hamburgerOpen}
                    color={color}
                    handleClick = {this.handleClick}
                    current={current}
                />
                <span className={`content-area ${willOpen}`}>
                    {this.props.children}
                </span>
                <Footer/>
            </div>
        </HelmetProvider>
        );
    }
}

export default Layout;
